import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-whoooshie',
  templateUrl: './whoooshie.component.html',
  styleUrls: ['./whoooshie.component.scss']
})
export class WhoooshieComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
